import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {inject} from "@angular/core";
import LocalStorageService from "../services/LocalStorage.service";

export const selectedRelationGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const localStorageService: LocalStorageService = inject(LocalStorageService);

  if (localStorageService.get('selectedRelation') === null) {
    return new RedirectCommand(router.parseUrl("/login/choose-relation"));
  }
  return true;
};
